<template>
    <snap-dialog
        :mountPoint="mountPoint"
        :width="840"
        :title="$t('fileWrapperDialog.title')"
        :onClose="onClose"
        class="file-wrapper"
    >
        <div slot="body" class="file-wrapper__body">
            <!--title-->
            <div class="file-wrapper__container">
                <p class="file-wrapper__container-title">
                    {{ $t('fileWrapperDialog.alertTitle') }}
                </p>
                <div class="file-wrapper__container-content">
                    <ElInput v-model="alertTitle" type="text" maxlength="40" />
                </div>
            </div>
            <!--type-->
            <div class="file-wrapper__container">
                <p class="file-wrapper__container-title">
                    <span>{{ $t('fileWrapperDialog.alertType') }}</span>
                </p>
                <div class="file-wrapper__container-group">
                    <div class="file-wrapper__container-content" style="margin-top: 8px;">
                        <ElCheckboxGroup v-model="alertType">
                            <div class="grid grid-cols-2 gap-2" style="grid-auto-flow: column; grid-template-rows: repeat(5, auto);">
                                <div v-for="item in fileWrapperTypeMapAll" :key="item" class="file-wrapper__container-checkbox group-child">
                                    <ElCheckbox :label="item">
                                        <div class="flex items-center">
                                            <span>{{ $t(`fileWrapperDialog.alertTypeMap.${item}`) }}</span>
                                            <span style="color: #8993A4;">{{ getTypeRegion(item) }}</span>
                                        </div> 
                                        <div v-if="$te(`fileWrapperDialog.alertTypeDescMap.${item}`)" style="color: #8993A4; margin-top: 4px;" v-html="$t(`fileWrapperDialog.alertTypeDescMap.${item}`)" />
                                    </ElCheckbox>
                                </div>
                            </div>
                        </ElCheckboxGroup>
                    </div>
                </div>
            </div>
            <!--email-->
            <div class="file-wrapper__container">
                <p class="file-wrapper__container-title">
                    {{ $t('fileWrapperDialog.sendTo') }}
                </p>
                <div class="file-wrapper__container-content">
                    <div v-if="selfEmail" class="file-wrapper__container-checkbox">
                        <ElCheckbox v-model="sendToMe" :class="{ error: isNoEmailSelected }">
                            {{ selfEmail }}
                        </ElCheckbox>
                    </div>
                    <!--输入收件人-->
                    <EmailAutoComplete
                        :inputing.sync="otherEmail"
                        :selected.sync="selected"
                        :class="{error: isNoEmailSelected}"
                        :placeholderContent="$t('fileWrapperDialog.sendToTip')"
                        :getEmailList="getEmailAddressListApi"
                        :passportUrl="passportUrl"
                        scrollSelector=".file-wrapper .file-wrapper__body"
                    />
                    <!--确认发送给他人-->
                    <div v-show="showEmailToOtherTips" :class="['file-wrapper__email-other-tips', { 'error': isSentToOtherTipUnchecked || isNoEmailSelected }]">
                        <div class="file-wrapper__container-checkbox">
                            <ElCheckbox v-model="sendToOther" :class="{ error: isSentToOtherTipUnchecked }">
                                {{ $t('fileWrapperDialog.EmailToOtherTips') }}
                            </ElCheckbox>
                        </div>
                    </div>
                    <!--错误提醒-->
                    <div v-if="isSentToOtherTipUnchecked || isNoEmailSelected || !isAllEmailValid" class="file-wrapper__email-errmsg">
                        <span v-if="isSentToOtherTipUnchecked">{{ $t('fileWrapperDialog.needConfirmHaveConsent') }}</span>
                        <span v-if="isNoEmailSelected">{{ $t('fileWrapperDialog.noEmailAdd') }}</span>
                        <span v-if="!isAllEmailValid">{{ $t('fileWrapperDialog.emailNotExist') }}</span>
                    </div>
                </div>
            </div>
            <!--frequency-->
            <div class="file-wrapper__container file-wrapper__frequency">
                <p class="file-wrapper__container-title">
                    {{ $t('fileWrapperDialog.frequency') }}
                </p>
                <div class="file-wrapper__container-content clearfix">
                    <ElSelect v-model="fullFq" popperClass="file-wrapper__frequency-popper" @change="frequencyTypeChange">
                        <ElOption
                            v-for="item in fqType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </ElSelect>
                    <ElSelect v-model="fullDate" popperClass="file-wrapper__frequency-popper">
                        <ElOption
                            v-for="item in fqDates"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </ElSelect>
                </div>
            </div>
            <!--alert-no-update-->
            <div class="file-wrapper__container">
                <div class="file-wrapper__container-content">
                    <div class="file-wrapper__container-checkbox">
                        <ElCheckbox v-model="alert_no_update">
                            {{ $t('fileWrapperDialog.alertNoUpdate') }}
                        </ElCheckbox>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="file-wrapper__footer">
            <button type="button" class="file-wrapper__cancel" @click="onClose">
                {{ $t('fileWrapperDialog.cancel') }}
            </button>
            <button type="submit" :class="['file-wrapper__confirm', { 'file-wrapper__confirm--disabled': titleLoading || isSubmitting }]" @click="submit">
                {{ $t('fileWrapperDialog.submit') }}
            </button>
        </div>
    </snap-dialog>
</template>

<script>
import SnapDialog from 'library-@/components/snap-ui/dialog';
import { createFileWrapperAlert } from '@/lib/api';
import validations from './validations';
import { Select, Option, CheckboxGroup, Checkbox, Input } from 'element-ui';
import _ from 'lodash';
import Vue from 'vue';
import appCache from '../../services/app-cache';
import { getEmailAlertUnusedTitleApi } from '../../../../../components/apis/email_alert_api/email_alert';
import {  ALL_FILE_WRAPPER_TYPE } from 'library-@/email-alert/field-config';
import { HOME_URI, ACCOUNT_URI } from 'library-@/config/apiConfig';
import { EmailAlert as PtEmailAlert, Toast } from 'patsnap-biz';
import { getEmailAddressListApi } from 'library-@/apis/email_alert_api/email_alert';
import '@patsnap-ui/icon/assets/solid/info.svg';


export default {
    name: 'CreateFileWrapperAlert',
    components: {
        EmailAutoComplete: PtEmailAlert.EmailAutoComplete,
        SnapDialog,
        // PtIcon: Icon,
        ElSelect: Select,
        ElOption: Option,
        ElInput: Input,
        ElCheckbox: Checkbox,
        ElCheckboxGroup: CheckboxGroup,
        // ElPopover: Popover,
    },
    props: {
        showDialog: {
            type: Boolean,
            required: true,
        },
        patentId: {
            type: String,
            require: true,
        },
        patentNo: {
            type: String,
            require: true,
        },
        onChange: {
            type: Function,
            default: () => null,
        },
        mountPoint: {
            type: String,
            default: '',
        },
        patent: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },
    data() {
        const fqType = [
            {
                label: this.$t('fileWrapperDialog.fullWeekly'),
                value: 'weekly',
            },
            {
                label: this.$t('fileWrapperDialog.fullMonthly'),
                value: 'monthly',
            },
        ];
        const fqDates = [];
        const weekdays = [];
        const dates = [];
        const weeklyI18n = {
            Sunday: this.$t('fileWrapperDialog.weekdays.Sunday'),
            Monday: this.$t('fileWrapperDialog.weekdays.Monday'),
            Tuesday: this.$t('fileWrapperDialog.weekdays.Tuesday'),
            Wednesday: this.$t('fileWrapperDialog.weekdays.Wednesday'),
            Thursday: this.$t('fileWrapperDialog.weekdays.Thursday'),
            Friday: this.$t('fileWrapperDialog.weekdays.Friday'),
            Saturday: this.$t('fileWrapperDialog.weekdays.Saturday'),
        };
        _.chain(weeklyI18n)
            .keys()
            .forEach(key => {
                weekdays.push({
                    label: weeklyI18n[key],
                    value: key,
                });
            })
            .value();
        for (let i = 1; i <= 28; i++) {
            dates.push({
                label: this.$t('fileWrapperDialog.date', {
                    n: i,
                    fix: (function(i) {
                        switch (Vue.config.lang) {
                            case 'de':
                            case 'en':
                                if (i > 3 && i < 19) return 'th';
                                switch (i % 10) {
                                    case 1:
                                        return 'st';
                                    case 2:
                                        return 'nd';
                                    case 3:
                                        return 'rd';
                                    default:
                                        return 'th';
                                }
                            case 'cn':
                            case 'jp':
                            case 'tw':
                                return '日';
                        }
                    })(i),
                }),
                value: i,
            });
        }
        dates.push({
            label: this.$t('fileWrapperDialog.lastDay'),
            value: 32,
        });
        return {
            otherEmail: '',
            selected: [],
            selfEmail: _.get(window, 'zPREFACE.accountInfo.email'),
            sendToMe: true,
            sendToOther: false,
            alert_no_update: false,
            shouldSubmit: true,
            alertTitle: '',
            titleLoading: false,
            weekdays,
            dates,
            fqType,
            fqDates,
            fullFq: fqType[0].value,
            fullDate: '',
            currentFq: fqType[0].value,
            currentDate: fqDates[0] ? fqDates[0].value : '',
            alertText: {
                success: this.$t('fileWrapperDialog.success'),
                deleteSuccess: this.$t('You have successfully removed email alert'),
            },
            isExpand: false,
            alertType: [],
            isSubmitting: false,
            passportUrl: `${ACCOUNT_URI}/user-settings/#`,
        };
    },
    computed: {
        showEmailToOtherTips() {
            if (!this.isAllEmailValid) return false;
            let allOtherEmails = _.map(_.filter(this.selected, item => item.type === 'email'), 'value');
            let allOtherGroups = _.map(_.filter(this.selected, item => item.type === 'group'), 'value');
            if (!_.isEmpty(_.trim(this.inputEmail))) {
                allOtherEmails.push(this.inputEmail);
            }
            allOtherEmails = _.uniq(allOtherEmails);
            allOtherGroups = _.uniq(allOtherGroups);
            if (allOtherEmails.length === 0 && allOtherGroups.length === 0) {
                return false;
            }
            if (allOtherEmails.length === 1 && _.indexOf(allOtherEmails, this.selfEmail) > -1 && allOtherGroups.length === 0) {
                return false;
            }
            return true;
        },
        isNoEmailSelected() {
            return !this.shouldSubmit && !this.sendToMe && this.selected.length === 0;
        },
        isSentToOtherTipUnchecked() {
            return !this.shouldSubmit && this.showEmailToOtherTips && !this.sendToOther;
        },
        isAllEmailValid() {
            let allOtherEmails;
            // 邮箱拼接，input框里的 + 自动提醒的
            allOtherEmails = _.map(_.filter(this.selected, item => item.type === 'email'), 'value');
            allOtherEmails = _.uniq(allOtherEmails);
            return _.every(allOtherEmails, email => {
                email = email.trim();
                return validations.checkEmail(email);
            });
        },
        fileWrapperTypeMapAll() {
            return ALL_FILE_WRAPPER_TYPE;
        },
        alertLink() {
            return `${HOME_URI}/alert`;
        },
    },
    watch: {
        sendToOther(val) {
            if (val) {
                this.shouldSubmit = true;
            }
        },
        sendToMe(val) {
            if (val) {
                this.shouldSubmit = true;
            }
        },
    },
    mounted() {
        // 初始默认weekly
        this.fullFq = 'weekly';
        this.frequencyTypeChange('weekly');
        this.getDefaultTitle();
    },
    created() {
        if (!this.selfEmail) this.sendToMe = false;
        this.getEmailAddressListApi = getEmailAddressListApi;
    },
    methods: {
        getTypeRegion(type) {
            const typeRegionsMap = {
                'FILEWRAPPER_ALL_EVENTS': '',
                'FILEWRAPPER_OFFICE_ACTION': this.$t('fileWrapperDialog.supportCountries.US_EP_CN_JP'),
                'FILEWRAPPER_APPLICATION_DOCS': this.$t('fileWrapperDialog.supportCountries.US_EP_JP'),
                'FILEWRAPPER_ARGUMENTS_APPLICANT_RESPONSES':  this.$t('fileWrapperDialog.supportCountries.US_EP_JP'),
                'FILEWRAPPER_OTHERS_EVENTS': this.$t('fileWrapperDialog.supportCountries.EP_JP'),
                'CN_FILEWRAPPER_NOTIFICATION_TO_GRANT_PATENT_RIGHT':  this.$t('fileWrapperDialog.supportCountries.CN'),
                'CN_FILEWRAPPER_NOTICE_OF_TERMINATION_OF_RIGHT': this.$t('fileWrapperDialog.supportCountries.CN'),
                'CN_FILEWRAPPER_REPORT_ON_PATENT_EVALUATION':  this.$t('fileWrapperDialog.supportCountries.CN'),
                'CN_FILEWRAPPER_NOTICE_OF_AVOID_DOUBLE_PATENTING':  this.$t('fileWrapperDialog.supportCountries.CN'),
            };

            return typeRegionsMap[type] || '';
        },
        _updatePatentAlertStatusProxy({ patentId, alertStatus }) {
            this.onChange({ patentId, alertStatus });
            // 更新缓存
            appCache.update(this.patentId, { fileWrapperAlertSetStatus: alertStatus });
        },
        // 频率变更
        frequencyTypeChange(val) {
            this.currentFq = val;
            switch (this.currentFq) {
                case 'weekly':
                    this.fqDates = this.weekdays;
                    break;
                case 'monthly':
                    this.fqDates = this.dates;
                    break;
                default:
                    this.fqDates = null;
            }
            if (this.fqDates) {
                this.currentDate = this.fqDates[0].value;
                this.fullDate = this.currentDate;
            }
        },
        concatEmail() {
            // 邮箱拼接，input框里的 + 自动提醒的
            const allOtherEmails = this.selected.map(item => ({ ...item }));
            if (!_.isEmpty(_.trim(this.otherEmail))) {
                allOtherEmails.push({
                    type: 'email',
                    label: _.trim(this.otherEmail),
                    value: _.trim(this.otherEmail),
                });
            }
            return _.uniqBy(allOtherEmails, 'value');
        },
        validateValue() {
            if (!this.alertTitle.length) {
                Toast({
                    message: this.$t('fileWrapperDialog.titleEmptyTip'),
                    type: 'warning',
                    showClose: true,
                });
                return false;
            }

            if (!this.alertType.length) {
                Toast({
                    message: this.$t('fileWrapperDialog.typeError'),
                    type: 'warning',
                    showClose: true,
                });
                return false;
            }

            const concatEmail = this.concatEmail();
            if (!concatEmail.length && !this.sendToMe) {
                this.shouldSubmit = false;
                return false;
            } if (!this.isAllEmailValid) {
                this.shouldSubmit = false;
                return false;
            }
            let isOnlyMyself =
                (concatEmail.length === 1 && _.findIndex(concatEmail, item => item.value === this.selfEmail) !== -1) ||
                (concatEmail.length === 0 && this.sendToMe);
            if (!isOnlyMyself && !this.sendToOther) {
                this.shouldSubmit = false;
                return false;
            }
            const country = _.get(this.patent, 'PN', '').substr(0, 2);
            const allTypeList = ALL_FILE_WRAPPER_TYPE;
            let matchRes = false;
            for (const type of this.alertType) {
                if (allTypeList.includes(type)) {
                    matchRes = true;
                    break;
                }
            }
            if (!matchRes) {
                Toast({
                    message: this.$t(`fileWrapperDialog.alertDisabled${country}`),
                    type: 'warning',
                    showClose: true,
                });
                return false;
            }
            this.shouldSubmit = true;
            return true;
        },
        getTitleIndex(title) {
            const matchIndex = (title || '').match(/(\d)+$/img);
            const index = _.get(matchIndex, '[0]', '');
            return index ? `${index}` : '';
        },
        getDefaultTitle() {
            this.titleLoading = true;
            getEmailAlertUnusedTitleApi()
                .then((data) => {
                    const titleIndex = this.getTitleIndex(data);
                    this.alertTitle = this.$t('snapBusiness.commonEmailAlert.defaultName', { num: titleIndex }).trim();
                    this.titleLoading = false;
                });
        },
        // 保存
        submit() {
            if (!this.validateValue() || this.titleLoading || this.isSubmitting) return;

            let fullDate;
            switch (this.fullDate) {
                case 'Sunday':
                    fullDate = 7;
                    break;
                case 'Monday':
                    fullDate = 1;
                    break;
                case 'Tuesday':
                    fullDate = 2;
                    break;
                case 'Wednesday':
                    fullDate = 3;
                    break;
                case 'Thursday':
                    fullDate = 4;
                    break;
                case 'Friday':
                    fullDate = 5;
                    break;
                case 'Saturday':
                    fullDate = 6;
                    break;
                default:
                    fullDate = this.fullDate;
            }
            const concatEmail = this.concatEmail();
            let isOnlyMyself =
                (concatEmail.length === 1 && _.findIndex(concatEmail, item => item.value === this.selfEmail) !== -1) ||
                (concatEmail.length === 0 && this.sendToMe);
            let alertParam = {
                patentId: this.patentId,
                alert_frequency_date: fullDate,
                alert_frequency_type: this.fullFq[0].toUpperCase(),
                alert_no_update: this.alert_no_update,
                alert_send: concatEmail.map(item => ({ type: item.type, email: item.value })),
                send_to_myself: this.selfEmail ? this.sendToMe : false,
                terms_of_use: !isOnlyMyself,
                alert_type: this.alertType,
                alert_title: this.alertTitle,
                apno: this.patent.APN,
            };

            // 调用保存接口
            this.isSubmitting = true;
            createFileWrapperAlert(alertParam)
                .then(res => {
                    if (res.status) {
                        const restrictActive = _.get(res, 'data.restrict_active', false);
                        // 数据埋点
                        window.rvTrack((restrictActive ? 'Create File Wrapper Alert Limited' : 'Create File Wrapper Alert'), {});
                        this._updatePatentAlertStatusProxy({ patentId: this.patentId, alertStatus: true });
                        this.$emit('success');
                        Toast({
                            message: restrictActive ? this.$t('commonStatusCode.13250130_fake', { link: this.alertLink }) : this.alertText.success,
                            type: restrictActive ? 'warning' : 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true,
                        });
                    } else {
                        const errorCode = res.error_code > 0 && this.$te(`commonStatusCode.${res.error_code}`)
                            ? res.error_code : 400;
                        const errorParams = errorCode === 13250130 ? { link: this.alertLink } : _.get(res, 'error_params', {});
                        Toast({
                            message: this.$t(`commonStatusCode.${errorCode}`, errorParams),
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true,
                        });
                    }
                    this.isSubmitting = false;
                    this.$emit('update:showDialog', false);
                })
                .catch();
        },
        onClose() {
            this.$emit('update:showDialog', false);
        },
    },
};
</script>

<style lang="scss">
    .file-wrapper {
        /*modal样式覆盖*/
        .modal-container {
            padding: 20px;
            background-image: none;
        }
        .modal-header {
            font-size: 20px;
            font-weight: 500;
            color: #061632;
        }
        .modal-body {
            margin-top: 24px !important;
        }
        .modal-footer {
            padding: 0;
            padding-top: 16px;
            text-align: right;
        }
        .modal-close-btn {
            right: 20px;
            .patsnap-biz-icon {
                height: 24px !important;
                width: 24px !important;
                fill: #52607A !important;
            }
        }

        &__body {
            max-height: 520px;
            overflow-y: auto;
            padding-right: 5px;
        }
        &__container {
            margin-top: 16px;
            &:first-of-type {
                margin-top: 0;
            }
        }
        &__container-title {
            font-weight: 500;
            color: #061632;
            line-height: 24px;
        }
        &__container-subTitle {
            font-weight: 400;
            color: #495973;
            line-height: 24px;
        }
        &__container-group {
            padding: 8px 0 0 8px;
            border-radius: 4px;
            background-color: $bg-normal;
            margin-bottom: 8px;
            .group-child {
                margin: 5px 16px 13px 0;
                width: calc(100% - 16px);
            }
        }
        &__container-content {
            margin-top: 4px;
            line-height: initial;
            
            .el-checkbox-group {
                display: block;
                width: 100%;
            }
            
            .grid {
                display: grid;
                grid-template-columns: 5fr 4fr;
                gap: 1rem;
                grid-auto-flow: column;
                grid-template-rows: repeat(5, auto);

                .file-wrapper__container-checkbox {
                    width: 100%;
                    height: 100%;
                    margin: 0;  // 移除所有边距
                    padding: 5px 0;  // 改用 padding 来控制间距

                    .el-checkbox {
                        width: 100%;
                        height: 100%;
                        
                        .el-checkbox__label {
                            width: calc(100% - 20px);
                            max-width: none;
                            display: block;  // 确保标签占满空间
                        }
                    }
                }
            }
        }
        &__container-checkbox {
            display: inline-block;
            line-height: initial;
            margin: 5px 0;
            width: 100%;
            &:last-of-type {
                margin-right: 0;
            }
            &__info {
                position: relative;
            }
            &__icon {
                position: absolute;
                top: -5px;
                fill: $text-disable !important;
            }
            .el-checkbox {
                width: 100%;
                .el-checkbox__label {
                    width: calc(100% - 20px);
                    max-width: none;
                }
            }
        }
        &__frequency {
            .el-select {
                width: calc((100% - 15px) / 2);
                float: left;
                &:last-child {
                    margin-left: 11px\9\0; /*fix IE9 bug*/
                    float: right;
                }
            }
        }
        &__email-errmsg {
            color: #d13649;
            padding-top: 5px;
        }
        &__email-other-tips {
            line-height: normal;
            background: #f8f8f8;
            border-radius: 3px;
            margin-top: 10px;
            padding: 5px 9px;
            color: #666;
            position: relative;
            &.error {
                background: #fbeeee;
                border: 1px solid #d13649;
            }
        }
        &__confirm, &__cancel{
            font-size: 16px;
            padding: 0 16px;
            min-width: 120px;
            text-align: center;
            height: 36px;
            line-height: 34px;
            border-radius: 4px;
            cursor: pointer;
        }
        button.file-wrapper__confirm {
            background-color: #45a321;
            border-color: transparent;
            color: #fff;
            &:hover {
                background-color: #3d921d;
                border-color: transparent;
            }
            &--disabled,
            &--disabled:hover {
                background-color: #c6e3bb;
                cursor: not-allowed;
            }
        }
        button.file-wrapper__cancel {
            text-align: center;
            background-color: #ebecf0;
            border-color: transparent;
            margin-right: 8px;
            &:hover {
                background-color: #dfe1e6;
                border-color: transparent;
            }
        }
        .email-auto-complete {
            margin-top: 5px;
        }

        /*覆盖element-ui样式*/
        .el-input__inner {
            height: 32px;
            line-height: 32px;
            border: 1px solid #B3BAC5;
            &:hover, &:focus {
                border-color: #B3BAC5;
            }
        }
        .el-checkbox {
            display: flex;
            align-items: flex-start;
            margin-right: 0;
            .el-checkbox__input {
                height: 14px !important;
                line-height: 14px !important;
            }
            .el-checkbox__inner {
                width: 14px !important;
                height: 14px !important;
                &::after {
                    top: 0;
                    left: 3px;
                }
            }
            .el-checkbox__label {
                padding-left: 6px;
                color: #061632 !important;
                font-weight: 400;
                line-height: 14px;
                white-space: normal;
                max-width: 300px;
                word-break: break-word;
            }
            &.error {
                .el-checkbox__inner {
                    border-color: #d13649 !important;
                }
            }
        }
        .el-select {
            .el-input__inner {
                border-color: #B3BAC5 !important;
            }
            .el-input {
                .el-input__suffix {
                    background-image: url('../../assets/images/icon-caret-down.png');
                    height: 24px;
                    width: 24px;
                    top: 50%;
                    transform: translateY(-50%);
                    -ms-transform: translateY(-50%);
                    .el-input__suffix-inner {
                        display: none;
                    }
                }
                &.is-focus {
                    .el-input__suffix {
                        transform: translateY(-50%) rotate(180deg);
                        -ms-transform: translateY(-50%) rotate(180deg);
                    }
                }
            }
        }
    }

    /*frequency-popper样式*/
    .file-wrapper__frequency-popper {
        border-color: #B3BAC5;
        padding: 4px 8px;
        .popper__arrow {
            display: none;
        }
        .el-select-dropdown__item {
            padding: 0 8px;
            border-radius: 4px;
            &.selected {
                color: #1976d2 !important;
                font-weight: 400 !important;
            }
            &.hover {
                background-color: #fff !important;
            }
            &:hover {
                background-color: #ebecf0 !important;
            }
        }
        &[x-placement^=bottom] {
            margin-top: 4px;
        }
        &[x-placement^=top] {
            margin-bottom: 4px;
        }
    }
</style>
